<template>
  <div 
    class="pa-4 mt-5">
    <v-layout wrap>
      <v-flex>
        <section>

          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Hapus Data

                <v-spacer/>

                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->

                <v-icon 
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->

              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Jadwal Visit</b> yang Anda pilih?

                <div v-if="message.error.length > 0"
                  class="text-center mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>


              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->

              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>

                <v-btn
                  rounded
                  @click="deletes()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, Hapus
                </v-btn>

                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.allDelete"
            @keydown.esc="dialog.allDelete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Hapus Data

                <v-spacer/>

                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>

                <v-icon 
                  @click="dialog.allDelete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->

                <v-icon 
                  @click="dialog.allDelete = false; dialog.fullscreen = false; selected.delete = [];"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->

              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Apakah Anda yakin menghapus semua data <b class="font-weight-bold black--text">Jadwal Visit</b>?

                <div v-if="message.error.length > 0"
                  class="text-center mt-4">
                  <div
                    class="error--text d-flex align-start">
                    <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                    
                    <span
                      class="ml-1">
                      {{ message.error }}
                    </span>
                  </div>
                </div>
              </v-card-text>


              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->

              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>

                <v-btn
                  rounded
                  @click="deletesAll()"
                  :loading="process.delete"
                  :disabled="process.delete"
                  width="190"
                  height="45"
                  elevation="0"
                  color="#1814F3"
                  class="fs-16 white--text text-capitalize border-radius">
                  Ya, Hapus
                </v-btn>

                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.allDelete = false; dialog.fullscreen = false; selected.delete = [];"
                  :disabled="process.delete"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          
          <!-- <div class="color-dark-blue fs-22 font-weight-bold">
            Detail <span v-if="Object.keys(detail).length > 0">{{ detail.sales_name }}</span>
          </div> -->

          <v-row
            class="pa-0 ">
            <v-col 
              cols="12"
              class="py-0">
              <v-card 
                flat
                min-height="calc(100vh - 245px)"
                style="border-radius: 6px;">
                <v-card-text
                  v-if="process.form" 
                  class="pb-0 my-4" style="height: 700px; display: flex; align-items: center; justify-content: center;">
                  <div class="text-center">
                    <div class="mb-2 title">
                      Mohon Tunggu...
                    </div>
                    <v-progress-circular
                      indeterminate
                    ></v-progress-circular>
                  </div>
                </v-card-text>

                <v-card-text v-if="!process.form && Object.keys(detail).length > 0">
                  <div class="d-flex mb-4 align-center">
                    <div>
                      <div class="fs-18 black--text font-weight-bold">
                        Jadwal Visit <span v-if="Object.keys(detail).length > 0">{{ detail.sales_name }}</span>
                      </div>
                    </div>
                    <v-spacer />
                  </div>
                  <v-row
                    justify="end"
                    class="pa-4 py-0 pr-1">
                    <v-col cols="12" md="12" class="d-flex align-center">
                      <v-btn
                        color="#4B4B4B"
                        elevation="0"
                        :disabled="process.load"
                        :to="`/visit/jadwal/add/${detail.id}`"
                        class="body-2 white--text text-capitalize d-flex align-center ml-0"
                        style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                        <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                        
                        <span
                          class="ml-2">
                          Tambah
                        </span>
                      </v-btn>
                      <div v-if="user.id === '1'">
                        <v-tooltip 
                          top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="process.delete = false; dialog.allDelete = true"
  
                              v-bind="attrs"
                              v-on="on"
  
                              min-width="36"
                              height="36"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1 px-0"
                              style="font-weight: 600; border-radius: 10px;">
                              <v-icon size="20">mdi-trash-can-outline</v-icon>
                            </v-btn>
                          </template>
                          
                          <span>Hapus Semua</span>
                        </v-tooltip>
                      </div>
                      <v-autocomplete
                        v-on:change="fetchDetail()"
                        
                        filled
                        rounded
                        clearable
                        dense
                        @click:clear="filter.store_name = ''; fetchDetail();"

                        hide-details

                        color="#718EBF"
                        placeholder="Toko"
                        class="fs-12 little-placeholder ml-3"

                        
                        :items="toko"
                        item-value="name"
                        item-text="name"
                        :item-color="set_color"

                        v-model="filter.store_name"
                        
                        style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 180px">
                      </v-autocomplete>
                      <v-autocomplete
                        v-on:change="fetchDetail()"
                        
                        filled
                        rounded
                        clearable
                        dense
                        @click:clear="filter.customer_id = ''; fetchDetail();"

                        hide-details

                        color="#718EBF"
                        placeholder="Customer"
                        class="fs-12 little-placeholder ml-3"

                        
                        :items="customer_list"
                        item-value="id"
                        item-text="name"
                        :item-color="set_color"

                        v-model="filter.customer_id"
                        
                        style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 180px">
                      </v-autocomplete>

                      <v-autocomplete
                        v-on:change="fetchDetail()"
                        
                        filled
                        rounded
                        clearable
                        @click:clear="filter.category = ''; fetchDetail();"

                        hide-details

                        color="#718EBF"
                        dense
                        placeholder="Tipe Visit"
                        class="fs-12 little-placeholder ml-3"

                        
                        :items="category"
                        item-value="id"
                        item-text="title"
                        :item-color="set_color"

                        v-model="filter.category"
                        
                        style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 180px">
                      </v-autocomplete>
                    
                      <v-text-field
                        @click:clear="search = ''; fetchDetail();"
                        v-on:keyup.enter="fetchDetail()"

                        filled
                        rounded
                        dense

                        hide-details
                        placeholder="Cari data yang Anda butuhkan . . ."
                        append-icon="mdi-magnify"
                        clearable
                        class="ml-3 fs-12 little-placeholder"

                        v-model="search"
                        style="border-radius: 6px; background: #d9e8ff9c !important; max-width: 320px">
                      </v-text-field>

                      <!-- FREEZE COLUMN -->
                      <!-- <div class="ml-3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              elevation="0"
                              outlined
                              dark
                              min-width="36"
                              color="#7B7B7B"
                              class="text-capitalize px-0"
                              style="border-radius: 10px;"
                              v-bind="attrs"
                              v-on="on"
                              @click="dialog.freeze = true">
                              <v-icon size="18">mdi-table-split-cell</v-icon>
                            </v-btn>
                          </template>

                          <span>
                            Freeze
                          </span>
                        </v-tooltip>
                      </div> -->

                      <!-- HIDE COLUMN -->
                      <!-- <div class="ml-3">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              elevation="0"
                              outlined
                              dark
                              min-width="36"
                              color="#7B7B7B"
                              class="text-capitalize px-0"
                              style="border-radius: 10px;"
                              v-bind="attrs"
                              v-on="on"
                              @click="dialog.hide = true">
                              <v-icon size="18">mdi-eye-off-outline</v-icon>
                            </v-btn>
                          </template>

                          <span>
                            Hide
                          </span>
                        </v-tooltip>
                      </div> -->
                      <div class="text-right ml-3">
                        <v-icon size="30" v-if="show === 'table'" @click="show = 'calendar'; fetchDetail(pagination = { row: 50000, page: 1 })">mdi-calendar-month</v-icon>
                        <v-icon size="30" v-if="show === 'calendar'" @click="show = 'table'; fetchDetail(paginationList)">mdi-table</v-icon>
                      </div>
                      <div class="ml-2">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              @click="exports_excel()"
                              :loading="process.export_excel"
                              elevation="0"
                              dark
                              min-height="28"
                              small
                              min-width="28"
                              color="#097640"
                              class="text-capitalize px-0 white--text"
                              style="border-radius: 6px;"
                              v-bind="attrs"
                              v-on="on">
                              <v-icon size="18">mdi-microsoft-excel</v-icon>
                            </v-btn>
                          </template>

                          <span>
                            Export Excel
                          </span>
                        </v-tooltip>
                      </div>
                    </v-col>
                    <!-- <v-col cols="12" md="1">

                      <div class="text-right mt-4">
                        <v-icon size="30" v-if="show === 'table'" @click="show = 'calendar'">mdi-calendar-month</v-icon>
                        <v-icon size="30" v-if="show === 'calendar'" @click="show = 'table'">mdi-table</v-icon>
                      </div>
                    </v-col> -->
                  </v-row>
                  <div v-if="show === 'table'">
                    <div class="view">
                      <div v-if="!process.load" :class="process.load || list.length === 0 ? '' : 'wrapper'">
                        <table style="border-radius: 10px; width: 100%;" class="table">
                          <tr>
                            <th class="sticky-col one-col" style="z-index: 2; font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">Aksi</th>
                            <th @click="sortBy !== 'date' ? toSort('date') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Tanggal
                              <span v-if="sortBy === 'date'">
                                <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                                <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                              </span>
                            </th>
                            <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Kode Outlet
                              <span v-if="sortBy === 'customer_code'">
                                <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                                <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                              </span>
                            </th>
                            <th @click="sortBy !== 'store_name' ? toSort('store_name') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Nama Toko
                              <span v-if="sortBy === 'store_name'">
                                <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                                <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                              </span>
                            </th>
                            <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Alamat Toko
                            </th>
                            <th @click="sortBy !== 'customer' ? toSort('customer') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Nama Customer
                              <span v-if="sortBy === 'customer'">
                                <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                                <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                              </span>
                            </th>
                            <th @click="sortBy !== 'category' ? toSort('category') : toDesc();" style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;">
                              Type Visit
                              <span v-if="sortBy === 'category'">
                                <v-icon v-if="sortDesc === '-'">mdi-arrow-down-thin</v-icon>
                                <v-icon v-if="sortDesc === ''">mdi-arrow-up-thin</v-icon>
                              </span>
                            </th>
                            <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left; z-index: 1;">
                              Map Alamat
                            </th>
                            <!-- <th style="font-size: 12px !important; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: left;"></th> -->
                            <!-- <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: center;">Realisasi</th>
                            <th style="font-size: 14px !important; z-index: 1; border: 1px solid #ededed; border-left: none; padding: 8px 12px; text-align: right;">Selisih</th> -->
                          </tr>
                          <tr v-for="(item, index) in list" :key="index" @click="selected.row = index" :class="selected.row === index ? 'selected' : ''">
                            <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 120px; min-width: 120px; max-width: 120px; padding: 8px 12px; text-align: center;">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                  :to="`/visit/jadwal/edit/${$route.params.id}?id=${item.id}`"
                                    
                                    v-bind="attrs"
                                    v-on="on"

                                    min-width="28"
                                    small
                                    rounded
                                    color="blue"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-square-edit-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Ubah</span>
                              </v-tooltip>
                              <!-- <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                  :to="`/visit/jadwal/detail/${item.id}`"
                                    
                                    v-bind="attrs"
                                    v-on="on"
                                    
                                    min-width="28"
                                    small
                                    rounded
                                    color="green"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-information-outline</v-icon>
                                  </v-btn>
                                </template>

                                <span>Detail</span>
                              </v-tooltip> -->
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    @click="toDelete(item.id)"

                                    v-bind="attrs"
                                    v-on="on"

                                    min-width="28"
                                    small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon small>mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </template>
                                
                                <span>Hapus</span>
                              </v-tooltip>
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">{{ item.date | date }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; border-left: none; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                              {{ item.customer_code }}
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px; width: 1px; white-space: nowrap; text-align: left;">
                              <a target="_blank" :href="`/customer/data/detail/${item.customer_id}`">
                                {{ item.store_name }}
                              </a>
                            </td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;  width: 200px; min-width: 200px; text-align: left;">{{ item.store_address }}, {{ item.store_village_name }}, {{ item.store_subdistrict_name }}, {{ item.store_city_name }}, {{ item.store_province_name }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;  width: 1px; white-space: nowrap; text-align: left;">{{ item.customer }}</td>
                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;  width: 1px; white-space: nowrap; text-align: left;">{{ item.category === 'weekly' ? 'Mingguan' : item.category === 'biweekly' ? 'Dua Mingguan' : 'Bulanan' }}</td>

                            <td style="font-size: 12px; border: 1px solid #ededed; padding: 8px 12px; padding-right: 50px;  width: 1px; white-space: nowrap; text-align: left;">
                              <gmap-map
                                :center="{ lat: (item.store_latitude*1), lng: (item.store_longitude*1) }"
                                :zoom="16"
                                :options="{
                                  zoomControl: true,
                                  mapTypeControl: false,
                                  scaleControl: false,
                                  streetViewControl: false,
                                  rotateControl: false,
                                  fullscreenControl: true,
                                  disableDefaultUi: false
                                }"
                                style="width: 200px; height: 200px;">

                                <gmap-marker
                                  :position="{ lat: (item.latitude*1), lng: (item.longitude*1) }">
                                </gmap-marker>
                              </gmap-map>
                            </td>
                            
                            <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">{{ (item.realisasi*1) | price }}</td> -->
                            <!-- <td :style="((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' : 'background: #FFCDD2;'" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 150px; min-width: 150; max-width: 150px; padding: 8px 12px; text-align: left;">
                              {{ ((item.nominal*1) + (item.nominal_sp2b*1)) === (item.realisasi*1) ? '' :((item.nominal*1) + (item.nominal_sp2b*1)) > (item.realisasi*1) ? '-' : '+'}}
                              {{ (((item.nominal*1) + (item.nominal_sp2b*1)) - (item.realisasi*1)) | price }}
                            </td> -->
                          </tr>
                        </table>
                      </div>

                      <v-card-text
                        v-if="process.load" 
                        class="pb-0 my-4" 
                        style="height: calc(100vh - 350px); display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <div class="mb-4 title">
                            Mohon Tunggu . . .
                          </div>

                          <v-progress-linear
                            :color="set_color"
                            indeterminate
                            rounded
                            height="10">
                          </v-progress-linear>
                        </div>
                      </v-card-text>

                      <v-card-text
                        v-if="!process.load && list.length === 0"
                        class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                        <div class="text-center">
                          <v-img 
                            class="mx-auto"
                            contain
                            alt="vuetify"
                            :width="90"
                            :height="90"
                            :src="require('@/assets/image/empty.png')">
                            <!-- <template v-slot:placeholder>
                              <v-row
                                class=" "
                                align="center"
                                justify="center">
                                <v-progress-circular 
                                  indeterminate 
                                  :color="set_color">
                                </v-progress-circular>
                              </v-row>
                            </template> -->
                          </v-img>
                          <div class="mt-3 fs-16">
                            Belum Ada Data
                          </div>
                        </div>
                      </v-card-text>

                      <pagination v-if="!process.load && pagination.total_data > 0"
                        @changePage="fetchDetail($event)" 
                        @reloadPage="fetchDetail($event)" 
                        :model="pagination" :display="paginationList"/>

                    </div>
                  </div>

                  <div v-if="show === 'calendar'">
                    <v-card-text class="pa-0">
                    <v-toolbar flat color="white">
                      <v-btn outlined 
                        class="mr-4 text-capitalize" 
                        color="grey darken-2" 
                        @click="date.now = ''">
                        <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                        Hari Ini
                      </v-btn>

                      <v-btn v-if="rps !== 'xs'"
                        fab text 
                        color="grey darken-2" 
                        @click="$refs.calendar.prev()">
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>

                      <v-btn v-if="rps !== 'xs'"
                        fab text 
                        color="grey darken-2" 
                        @click="$refs.calendar.next()">
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>

                      <v-toolbar-title v-if="$refs.calendar && rps !== 'xs'">
                        {{ $refs.calendar.title }}
                      </v-toolbar-title>

                      <v-spacer/>

                      <v-menu
                        bottom
                        right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                            outlined
                            color="grey darken-2"
                            v-bind="attrs"
                            v-on="on">
                            <span class="text-capitalize">
                              {{ filter.label }}
                            </span>
                            <v-icon right>
                              mdi-menu-down
                            </v-icon>
                          </v-btn>
                        </template>
                        <v-list>
                          <v-list-item 
                            v-for="(item, index) in menu"
                            :key="index"
                            @click="filter.label = item.label; filter.type = item.value;">
                            <v-list-item-title>
                              {{ item.label }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list>
                      </v-menu>
                    </v-toolbar>

                    <v-toolbar flat color="white" v-if="rps === 'xs'">
                      <v-btn
                        fab text 
                        color="grey darken-2" 
                        @click="$refs.calendar.prev()">
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>

                      <v-spacer/>

                      <v-toolbar-title v-if="$refs.calendar">
                        {{ $refs.calendar.title }}
                      </v-toolbar-title>

                      <v-spacer/>

                      <v-btn
                        fab text 
                        color="grey darken-2" 
                        @click="$refs.calendar.next()">
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>
                    </v-toolbar>
                  </v-card-text>

                  <v-card-text class="py-0">
                    <v-sheet height="600">
                      <v-calendar
                        ref="calendar"
                        color="#ffcbdc"
                        :type="filter.type"
                        v-model="date.now"
                        :events="listDate"
                        @click:event="showEvent"
                        @click:more="viewDay"
                        @click:date="viewDay">
                      </v-calendar>

                      <v-menu
                        v-model="selected.open"
                        :close-on-content-click="false"
                        :activator="selected.element"
                        offset-x>
                        <v-card v-if="Object.keys(selected.event).length > 0"
                          width="350"
                          style="border-radius: 15px;"
                          flat>
                          <v-toolbar
                            :color="selected.event.color"
                            dark>
                            <v-toolbar-title class="body-1 font-weight-bold text-capitalize">
                              {{ selected.event.customer }}
                            </v-toolbar-title>

                            <v-spacer/>

                            <v-btn icon
                              @click="selected.open = false">
                              <v-icon>mdi-close</v-icon>
                            </v-btn>
                          </v-toolbar>

                          <v-card-text class="body-1 text-capitalize font-weight-bold pb-0">
                            {{ selected.event.customer }}
                          </v-card-text>

                          <v-card-text class="body-2 font-weight-light text-first">
                            <p class="mb-2">
                              <v-icon small class="mr-1">mdi-calendar-month</v-icon>
                              <span v-if="selected.event.start === selected.event.end">
                                Tanggal <b>{{ selected.event.date | date }}</b>
                              </span>
                            </p>

                            <p class="mb-2">
                              <v-icon small class="mr-2">mdi-store</v-icon>
                              <span>
                                <b>{{ selected.event.store_name }}</b>
                              </span>
                            </p>

                            <p class="mb-2">
                              <v-icon small class="mr-2">mdi-map-marker</v-icon>
                              <span>
                                <b>{{ selected.event.store_address }}</b>
                              </span>
                            </p>

                            <div class="mt-6">
                              <a 
                                :href="`https://www.google.com/maps/search/?api=1&query=${selected.event.store_latitude},${selected.event.store_longitude}`"
                                style="color:#0000FF;text-align:left" 
                                  target="_blank">
                                    <iframe 
                                      width="300" 
                                      height="170" 
                                      frameborder="0" 
                                      scrolling="no" 
                                      marginheight="0" 
                                      marginwidth="0" 
                                      :src="`https://maps.google.com/maps?q=${selected.event.store_latitude},${selected.event.store_longitude}&hl=es&z=14&amp;output=embed`"
                                      >
                                    </iframe>
                                  </a>
                            </div>


                          </v-card-text>
                        </v-card>
                      </v-menu>
                    </v-sheet>
                  </v-card-text>
                  </div>

                  <div v-if="message.error.length > 0"
                    class="text-center my-4 d-flex align-center">
                    <div
                      class="error--text">
                      <v-icon size="18" color="red">mdi-alert-circle-outline</v-icon>
                      
                      <span
                        class="ml-1">
                        {{ message.error }}
                      </span>
                    </div>
                  </div>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions
                  class="">
                  <v-spacer/>
                  <v-btn
                    to="/visit/jadwal"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    width="140"
                    height="45"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4 border-radius"
                    style="font-weight: 600;">
                  
                      Kembali
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import moment from "moment"
  import axios from "axios";
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        dialog: {
          fullscreen: false,
          snackbar: false,
          freeze: false,
          hide: false,

          filter: false,

          form: false,
          delete: false,
          allDelete: false
        },

        menu: [
          {
            label: 'Bulan',
            value: 'month'
          },
          {
            label: 'Minggu',
            value: 'week'
          },
          {
            label: 'Hari',
            value: 'day'
          },
          {
            label: '4 Hari',
            value: '4day'
          }
        ],

        category: [
          {
            title: "Mingguan",
            id: "weekly"
          },
          {
            title: "Dua Mingguan",
            id: "biweekly"
          },
          {
            title: "Bulanan",
            id: "monthly"
          }
        ],
        filter: {
          year: new Date().getFullYear(),
          title: '',
          category: '',
          calendar: true,
          label: 'Bulan',
          type: 'month',
          customer_id: '',
          store_name: ''
        },
        picker: {
          date: false
        },
        date: {
          min: moment().format('Y-MM-DD'),
          now: moment().format('Y-MM-DD')
        },
        selected: {
          open: false,
          element: null,
          event: {},
          freeze: [],
          delete: [],
          row: []
        },
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        listDate: [],
        
        search: '',

        show: 'table',

        

        // date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        // menu: false,
        // modal: false,
        // menu2: false,
        
        form: {
          id: '',
          sales_id: '',
          customer_id: '',
          date: '',
          store_id: ''
        },

        customer: [],
        customer_list: [],
        toko: [],
        sales_region_id: '',

        sales: [],
        sortBy: 'id',
        sortDesc: '-',

        options: {},
        headers: [],
        list: [],
        detail: {},
        pagination: {},

        lastIndex: 0,
        limit: 50000000000000,

        process: {
          load: false,

          delete: false,
          form: false,
          export_excel: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination_other.vue'),
    },
    watch: {
      // 'options': {
      //   handler () {
      //     let pagination = { row: this.limit, page: 1 }
          
      //     this.fetchDetail(pagination)
      //   },
      //   deep: true
      // }
    },
    computed: {
      rps () {
        return this.$vuetify.breakpoint.name
      },
      user () {
        return this.$store.state.user
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },

      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      },

      years () {
        let max = new Date().getFullYear()+2, min = max - 2, years = []

        for (let i = max; i >= min; i--) {
          years.push({
            text: i,
            value: i
          })
        }

        return years
      }
    },
    mounted () {
      this.fetchDetail()
      this.fetchCategoru()
    },
    methods: {
      toSort(name) {
        this.sortBy = name
        this.sortDesc = ''
        this.fetchDetail()
      },
      toDesc() {
        this.sortDesc === '-' ? this.sortDesc = '' : this.sortDesc = '-'
        this.fetchDetail()
      },
      async fetchToko() {
        
        this.toko = []
        let params = {
          sales_region_id: this.detail.sales_region_id,
          pagination_bool: false,
          status: 'approved'
          // id: this.form.customer_id
        }
  
        await get('admin/toko/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.toko = res.results.data
            this.changeStore()
          }
        })
      },
      async fetchCustomor () {
        // this.process.load = true

        // this.limit = pagination.row

        let params = {
          limit: 10000000000000,
          status: 'approved',
          sales_region_id: this.detail.sales_region_id
        }

        // admin/services/data
        
        await get(`admin/customer/data`, { params })
        .then(response => {
          let res = response.data
          
          
          if (res.status === 200) {
            this.customer_list = res.results.data
          }
        })
      },
      async fetchCategoru() {
        this.process.form = true
         let params = {
          id: this.$route.params.id
        }

        await get(`admin/jadwal/data`, { params })
        .then(response => {
          let res = response.data
          
          if (res.status === 200) {
            this.detail = res.results.data[0]
            this.fetchCustomor()
            this.fetchToko()
          this.process.form = false
          }
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },

      viewDay ({ date }) {
        this.focus = date
        this.filter.type = 'day'
        this.filter.label = 'Hari'
      },
      rnd (a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selected.event = event
          this.selected.element = nativeEvent.target
          setTimeout(() => {
            this.selected.open = true
          }, 10)
        }

        if (this.selected.open) {
          this.selected.open = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },

      async fetchDetail (pagination = { row: 50, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = this.show === 'calendar' ? this.paginationList : pagination

        let params = {
          sales_id: this.$route.params.id,
          limit: pagination.row,
          page: pagination.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          customer_id: this.filter.customer_id,
          search: this.search,
          category: this.filter.category,
          store_name: this.filter.store_name,
          // unit_id: this.$store.state.user.unit_id === '0' || this.$store.state.user.unit_id === 0 ? '' : this.$store.state.user.unit_id
        }

        this.selected.row = []

        // admin/services/data
        
        await get(`admin/jadwal/detail`, { params })
        .then(response => {
          let res = response.data
          
          this.process.load = false
          
          this.list = []
          this.pagination = {}
          
          if (res.status === 200) {
            this.headers = [
              {
                text: '',
                width: '120px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'start',
                format: 'action'
              },
              {
                text: 'No',
                width: '80',
                value: 'index',
                freeze: true,
                hide: false
              },
              {
                text: 'Tanggal Visit',
                width: '200px',
                value: 'date',
                freeze: false,
                hide: false,
                format: 'date'
              },
              {
                text: 'Nama Customer',
                width: '250px',
                value: 'customer',
                freeze: true,
                hide: false
              },
              {
                text: 'Nama Toko',
                width: '200px',
                value: 'store_name',
                freeze: false,
                hide: false
              },
              {
                text: 'Alamat Toko',
                width: '250px',
                value: 'store_address',
                freeze: false,
                hide: false,
                format: 'link'
              },
              
            
            ]
    
            this.list = res.results.data
            let data = res.results.data
            this.listDate = []

            console.log(data)

            data.map((obj) => {
              this.listDate.push({
                name: obj.store_name,
                customer: obj.customer,
                customer_id: obj.customer_id,
                customer_plafon: obj.customer_plafon, 
                id: obj.id,  
                sales: obj.sales, 
                sales_id: obj.sales_id, 
                store_address: obj.store_address, 
                store_id: obj.store_id, 
                store_images: obj.store_images, 
                store_latitude: obj.store_latitude, 
                store_longitude: obj.store_longitude, 
                store_name: obj.store_name, 
                store_notes: obj.store_notes, 
                store_pic_mobilephone: obj.store_pic_mobilephone, 
                store_pic_name: obj.store_pic_name,
                store_type: obj.store_type,
                date: obj.date,
                start: obj.date,
                end: obj.date,
                color: this.set_color
              })
            })
            this.pagination = res.results.pagination

            // this.list.map(obj => {
            //   obj.is_active = obj.is_active === 'Aktif' ? true : false
            // })

            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1


            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
          }
        })
      },


      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/jadwal/delete`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
      },

      async deletesAll () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/jadwal/delete_all`, {
          data: {
            sales_id: this.$route.params.id
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.allDelete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
      },

      async exports_excel () {
        this.message.error = ''

        this.process.export_excel = true

        let params = {
          
          sales_id: this.$route.params.id,
          limit: this.paginationList.row,
          page: this.paginationList.page,
          sort: `${this.sortDesc}${this.sortBy}`,
          // order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          customer_id: this.filter.customer_id,
          search: this.search,
          category: this.filter.category,
          store_name: this.filter.store_name,
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/admin/jadwal/detail/export`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export_excel = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=')[1]
          // let filename = ''

          // if (disposition && disposition.indexOf('inline') !== -1) {
          //   var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          //   var matches = filenameRegex.exec(disposition);
          //   if (matches != null && matches[1]) { 
          //     filename = matches[1].replace(/['"]/g, '');
          //   }
          // }
          console.log(fileName)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport Excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', fileName)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>

<style>
/* ::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  background-color: #F5F5F5;
}
::-webkit-scrollbar-track{
  background-color: #F5F5F5;
  border-radius: 10px;
} */
::-webkit-scrollbar-thumb{
  border-radius: 10px;
  background-color: #718EBF;
}
table, th, td {
  /* border: 1px solid #ededed;
  border-collapse: collapse; */
  /* border: thin ridge black; */
  border-spacing: 4px;
  border-collapse: collapse;
}

.view {
  margin: auto;
  /* width: 100%; */
}

.wrapper { 
  overflow-y: auto; 
  height: calc(100vh - 310px); 
} 

.wrapper-none { 
  /* overflow-y: auto; 
  height: calc(100vh - 270px);  */
} 

.wrapper th { 
  position: sticky; 
  top: 0; 
  background-color: white !important;
} 
.sticky-col {
  position: -webkit-sticky;
  position: sticky;
  background-color: white !important;
}

.one-col {
  width: 60px;
  min-width: 60px;
  max-width: 60px;
  left: 0px;
}

.second-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 150px;
}

.three-col {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
  left: 300px;
}

.four-col {
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  left: 450px;
}

tr:hover {background-color: #1976d236;}
tr.selected {background-color: #1976d236;}
</style>